import React from 'react';
import * as Form from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { useNavigation } from '@react-navigation/native';
import { NumberSchema } from 'yup';

import useIsMounted from '@src/hooks/useIsMounted';
import { i18yup } from '@src/i18n';
import { setLabels } from '@src/store/authentication/actions';

import { FormData } from './types';

const useForm = () => {
  const [loading, setLoading] = React.useState(false);
  const isMounted = useIsMounted();
  const dispatch = useDispatch();
  const navigation = useNavigation();

  const form = Form.useForm<FormData>({
    validationSchema: i18yup.object<FormData>({
      travellingTypePreference: i18yup.number().oneOf([1, 2]) as NumberSchema<
        1 | 2
      >,
    }),
  });

  const handleSubmit = React.useCallback(
    async (data: FormData) => {
      try {
        setLoading(true);
        dispatch(
          setLabels({ travellingTypePreference: data.travellingTypePreference })
        );
        // @ts-ignore
        navigation.replace('SetupLabels');
      } catch (e) {
        console.log(e);
      }

      if (isMounted) {
        setLoading(false);
      }
    },
    [dispatch, isMounted, navigation]
  );

  return React.useMemo(
    () => ({
      form,
      handleSubmit: form.handleSubmit(handleSubmit),
      loading,
    }),
    [form, handleSubmit, loading]
  );
};

export default useForm;
